import { render, staticRenderFns } from "./jwplayer.vue?vue&type=template&id=239f2ff6&"
import script from "./jwplayer.vue?vue&type=script&lang=js&"
export * from "./jwplayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports